
import { Component, Vue, Prop } from 'vue-property-decorator'
import { IAppForm } from './IAppForm'
import { ApplicationModule } from '@/store'
import CFInput from '../inputs/CFInput'
import DefaultValue from "@/const/default_value";

	@Component({
	  name: 'AmountToFinance',
		computed: {
			DefaultValue() {
				return DefaultValue
			}
		}
	})
export default class AmountToFinance extends Vue implements IAppForm {
  // #region Props

		@Prop() wizardIndex!: number;

		// #endregion

		// #region Data

		get value () {
		  return ApplicationModule.form
		}

		// #endregion

		// #region Methods

		submit () {
		  if (!this.validate()) { return }

		  this.$emit('submit', this.wizardIndex)
		}

		validate () {
		  return (this.$refs.amountToFinanceInput as unknown as CFInput).validate()
		}

		previous () {
		  this.$emit('previous')
		  ApplicationModule.updateForm(ApplicationModule.formCopy)
		}

  // #endregion
}
